import * as defaultImport from "@splunk/visualizations/Area";
export * from "@splunk/visualizations/Area";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
